import * as React from "react"
import { Modal, Form, Button } from "react-bootstrap"
import MaskedInput from "react-maskedinput"
import InvitationStatusGridRecord from "../../api/InvitationStatus/Model/InvitationStatusGridRecord"
import { EmailRegexp, PhoneRegexp } from "../../config/Constants"
import ResendInvitation from "../../api/InvitationStatus/ResendInvitation"
import ResendModel from "../../api/InvitationStatus/Model/ResendModel"
import { Subscription } from "rxjs"
import { toast } from "react-toastify"
import FormatPhone from "../../formatters/FormatPhone"
import DeleteModel from "../../api/InvitationStatus/Model/DeleteModel"
import DeleteInvitation from "../../api/InvitationStatus/DeleteInvitation"
import ActionButton from "../ActionButton"

interface ResendInvitationModalProps {
  show: boolean
  modalData?: InvitationStatusGridRecord
  onHide: () => void
  onDeleteInvitation: () => void
  onResendInvitation: () => void
}

interface ResendInvitationModalState {
  email: string
  phone: string
  emailValid: boolean
  phoneValid: boolean
  deletingInvitation: boolean,
  resendingtInvitation: boolean
}

export default class ResendInvitationModal extends React.PureComponent<ResendInvitationModalProps, ResendInvitationModalState> {
  resendInvitationSubscription?: Subscription
  deleteInvitationSubscription?: Subscription

  state: ResendInvitationModalState = {
    email: "",
    phone: "",
    emailValid: false,
    phoneValid: false,
    deletingInvitation: false,
    resendingtInvitation: false
    
  }

  isEmailValid = (value: string) => EmailRegexp.test(value)

  isPhoneValid = (value: string) => PhoneRegexp.test(value)

  handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value: string = e.target.value

    this.setState({ email: value, emailValid: this.isEmailValid(value) })
  }

  handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value: string = e.target.value

    this.setState({ phone: value, phoneValid: this.isPhoneValid(value) })
  }

  populateContacts = () => {
    const email = this.props.modalData ? this.props.modalData.UserName : ""
    const phone = this.props.modalData ? FormatPhone(this.props.modalData.ContactDetail) : ""

    this.setState({ email: email, phone: phone, emailValid: this.isEmailValid(email), phoneValid: this.isPhoneValid(phone) })
  }

  resendInvitation = () => {
    this.setState({ resendingtInvitation: true })
    const resend: ResendModel = {
      EmailAddress: this.state.email,
      Link: this.props.modalData?.Link || "",
      PhoneNumber: this.state.phone.replace(/-/g, "")
    }
    this.resendInvitationSubscription = ResendInvitation(resend).subscribe(
      data => {
        toast.success(data)
        this.props.onResendInvitation()
        this.setState({ resendingtInvitation: false })
      },
      error => {
        toast.error(error.message)
        this.setState({ resendingtInvitation: false })
      },
      () => this.setState({ resendingtInvitation: false })
    )
  }

  deleteInvitation = () => {
    this.setState({ deletingInvitation: true })

    const deleteModel: DeleteModel = {
      Link: this.props.modalData?.Link || ""
    }
    this.deleteInvitationSubscription = DeleteInvitation(deleteModel).subscribe(
      data => {
        toast.success(data)
        this.props.onDeleteInvitation()
        this.setState({ deletingInvitation: false })
      },
      (error) => {
        toast.error(error.message)
        this.setState({ deletingInvitation: false })
      },
      () => this.setState({ deletingInvitation: false })
    )
  }

  componentDidMount() {
    this.populateContacts()
  }

  componentWillUnmount() {
    this.resendInvitationSubscription && this.resendInvitationSubscription.unsubscribe()
    this.deleteInvitationSubscription && this.deleteInvitationSubscription.unsubscribe()
  }

  componentDidUpdate(prevProps: ResendInvitationModalProps) {
    if (prevProps.modalData !== this.props.modalData) {
      this.populateContacts()
    }
  }

  render() {
    const { show, onHide } = this.props;
    const deletingInvitation = this.state.deletingInvitation;
    const resendingtInvitation = this.state.resendingtInvitation;

    return <Modal backdrop="static" centered show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Resend/Delete Invitation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="adminEmail" className="required">
            <Form.Label>Email Address</Form.Label>
            <Form.Control type="text" isInvalid={!this.state.emailValid} onChange={this.handleEmailChange} value={this.state.email} />
            <Form.Control.Feedback type="invalid">Please enter valid email.</Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="adminPhone" className="required">
            <Form.Label>Personal Phone</Form.Label>
            <Form.Control type="text" as={MaskedInput} mask="111-111-1111" isInvalid={!this.state.phoneValid} onChange={this.handlePhoneChange} value={this.state.phone} />
            <Form.Text>This phone number will be used to validate the Administrator. Please provide a direct number or mobile number (not a main company number or extension)</Form.Text>
            <Form.Control.Feedback type="invalid">Please enter valid phone.</Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <ActionButton variant="primary" onClick={() => this.deleteInvitation()} disabled={!this.state.emailValid || !this.state.phoneValid} spin={deletingInvitation} disableOnSpin>
          Delete Invitation
        </ActionButton>
        <ActionButton variant="primary" onClick={() => this.resendInvitation()} disabled={!this.state.emailValid || !this.state.phoneValid} spin={resendingtInvitation} disableOnSpin>
          Resend Invitation
        </ActionButton>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  }
}
